import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';


@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  encapsulation:ViewEncapsulation.None
})
export class DateTimePickerComponent implements OnInit {
 @Input() field:any;
 @Input() form:any;
 @Input() formName:any;
 @Input() disabled: boolean = false;
 @Input() isReadOnly: boolean = false;
 @Input() isInValid: boolean = false;
 @Input() isEdit :boolean=false;
 
  constructor() { }


  ngOnInit() {

  }

}
